<template>
  <div
    class="h-[176px] w-full rounded-lg bg-gray-200/25 p-[9px] flex items-center justify-center"
  >
    <div
      v-if="thumbnail.stack?.length"
      class="relative h-full aspect-square flex items-center justify-center"
    >
      <div
        v-for="(stacked, index) in thumbnail.stack"
        :key="stacked.id"
        class="absolute h-[80%] aspect-square drop-shadow-[0_2px_8px_rgba(0,0,0,0.12)]"
        :style="stackStyle(index)"
      >
        <Thumbnail :type="stacked.type" :src="stacked.src" />
      </div>
    </div>

    <button
      v-else
      type="button"
      class="h-full aspect-square"
      :class="thumbnail.onClick ? 'cursor-pointer' : 'pointer-events-none'"
      @click="thumbnail.onClick?.()"
    >
      <Thumbnail :type="thumbnail.type" :src="thumbnail.src" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { Thumbnail } from '@dacr/library'
import type { SidebarThumbnail } from './types'

const { thumbnail } = defineProps<{ thumbnail: SidebarThumbnail }>()

const stackStyle = (index: number) => {
  const count = thumbnail.stack?.length ?? 0
  const rotate = index === 0 ? -8 : index === count - 1 ? 0 : 8
  return { transform: `rotate(${rotate}deg)`, zIndex: index }
}
</script>
